import React from "react";
import RunPayRollMonths from "./RunPayRollMonths";
import PayrollSummary from "./PayRollSummary";
import { Col, Row, Space, Typography, Avatar, Tag } from "antd";
import PayrollSteps from "./PayRollSteps";
import Box from "../../../components/Box/Box";
import InfiniteScrollList from "../../../components/Forms/ListView/InfiniteScrollList";
import { useSelector } from "react-redux";
import moment from "moment";

const { Text } = Typography;

const RunPayRoll: React.FC = () => {
    const params = useSelector(({ app }) => app?.params);
    const selectedMonth = params?.selectedMonth || moment().format('MMM YYYY');
    const currentMonth = moment(selectedMonth, 'MMM YYYY').format('MM-YYYY');

    const getStepColor = (step: string) => {
        const stepColors: Record<string, string> = {
            'leave_attendance': 'purple',
            'new_joinees_exits': 'cyan',
            'bonus_salary_revisions': 'green',
            'reimbursement_adhoc': 'pink',
            'salaries_hold_arrears': 'orange',
            'override': 'blue',
            'finalize': 'red',
            'preview': 'default',
            'general': 'default'
        };
        return stepColors[step] || 'default';
    };

    const formatTime = (date: string) => {
        return moment(date).format('MMM DD, YYYY HH:mm A');
    };

    const renderActivityItem = (item: any) => {
        const performedBy = item.performedBy;
        const employee = item.employeeId;

        return (
            <div style={{
                padding: '12px 0',
                borderBottom: '1px solid #f0f0f0',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    {performedBy && (
                        <Avatar
                            size="small"
                            src={performedBy.avatar}
                            style={{ backgroundColor: '#87d068' }}
                        >
                            {performedBy.firstName?.[0] || 'U'}
                        </Avatar>
                    )}
                    <Text strong style={{ fontSize: '13px' }}>
                        {item.action}
                    </Text>
                    {item.step && item.step !== 'general' && (
                        <Tag color={getStepColor(item.step)} >
                            {item.step.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                        </Tag>
                    )}
                </div>
                {item.remarks && (
                    <Text type="secondary" style={{ fontSize: '12px', marginLeft: '32px' }}>
                        {item.remarks}
                    </Text>
                )}
                {employee && (
                    <Text type="secondary" style={{ fontSize: '12px', marginLeft: '32px' }}>
                        Employee: {employee.firstName} {employee.lastName}
                    </Text>
                )}
                <Text type="secondary" style={{ fontSize: '11px', marginLeft: '32px' }}>
                    {formatTime(item.createdAt)}
                </Text>
            </div>
        );
    };

    return (
        <>
            <Space style={{ width: '100%' }} direction="vertical">
                <RunPayRollMonths />
                <PayrollSummary />
                <Row gutter={16}>
                    <Col span={16}>
                        <PayrollSteps />
                    </Col>
                    <Col span={8}>
                        <Box title={'Activity'} >
                            <InfiniteScrollList
                                apiUrl="/run-payroll/activities"
                                apiQuery={{ month: currentMonth }}
                                height={300}
                                renderItem={renderActivityItem}
                            />
                        </Box>
                    </Col>
                </Row>
            </Space>
        </>
    );
};

export default RunPayRoll;